import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
import moment from 'moment-mini';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Kartu Stok',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Kartu Stok',
        href: '/adm/logistic/laporan/kartu-stok',
        active: true,
      },
    ],
    form: {
      code_prod: '',
      id_product: '',
      date: '',
    },
    report: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeKartuStok(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getReportStok({ commit, state }) {
    commit('changeKartuStok', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`logistic/kartu-stok`, {
      start_date:
        data.form && data.form.date && data.form.date.length > 0
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form && data.form.date && data.form.date.length > 0
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
      id_gudang: data.form.id_gudang || '',
      id_product: data.form.id_product || '',
    });

    commit('changeKartuStok', {
      loading: false,
      report: result.data.object ? result.data.object : {},
    });

    return result.error ? false : true;
  },
};
